import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import '../profile.scss';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { Translate, translate } from 'react-jhipster';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_YYYYMMDD, Resources } from 'app/config/constants';
import { updateAttributeWithDataResidential } from '../user.reducer';

export interface IModalUpdateDataWithResidentialProps extends StateProps, DispatchProps {
  showModal: boolean;
  closeModal: Function;
  updateWithResidential: Function;
  isUpdateIdentity: boolean;
}

var isIdentity = true;
export interface IModalUpdateDataWithResidentialState {
  birthday: Date;
  required: boolean;
  resourceVerify: string;
  isLoginByIdentity: boolean;
}
class ModalUpdateDataWithResidential extends React.Component<IModalUpdateDataWithResidentialProps, IModalUpdateDataWithResidentialState> {
  constructor(props) {
    super(props);
  }

  state: IModalUpdateDataWithResidentialState = {
    birthday: null,
    required: false,
    resourceVerify: Resources[6].key,
    isLoginByIdentity: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.userProfile !== nextProps.userProfile) {
      this.checkExistsIdentity(nextProps.userProfile);
    }

    if (this.props.resUpdateAttr !== nextProps.resUpdateAttr) {
      this.setState({
        resourceVerify: Resources[6].key
      });
    }
  }

  // check when update with tax
  checkExistsIdentity = user => {
    let identity = '';
    if (user && user.attributes) {
      let arrIdentity = user.attributes.filter(item => item.name == 'identity');
      identity = arrIdentity.length > 0 ? arrIdentity[0].value : '';
    }
    if (identity) {
      this.setState({ isLoginByIdentity: true });
    } else {
      this.setState({ isLoginByIdentity: false });
    }
  };

  handleValidSubmit = (event, values) => {
    this.props.updateWithResidential(values, this.state.resourceVerify);
  };

  handleInvalidSubmit = (event, errors, values) => {
    if (errors) {
      window['autoFocus'](errors[0]);
    }
  };

  handleChangeDate = date => {
    this.setState({
      birthday: date
    });
  };
  closeModal = () => {
    this.setState({
      birthday: null,
      resourceVerify: Resources[6].key
    });
    this.props.closeModal();
  };
  bindingData = type => {
    switch (type) {
      case 'cn':
        return this.props.userProfile && this.props.userProfile.attributes
          ? this.props.userProfile.attributes.filter(item => item.name == type)
          : null;
      case 'identity':
        let identity = this.props.userProfile.attributes.filter(item => item.name == type);
        if (identity.length > 0 && identity[0].value && identity[0].value != '') {
          return identity;
        }
        return '';
      case 'citizenId':
        let citizen = this.props.userProfile.attributes.filter(item => item.name == 'citizenId');
        if (citizen.length > 0 && citizen[0].value && citizen[0].value != '') {
          return citizen;
        }
        return '';
    }
  };
  bindingDataBirthDay = type => {
    if (this.props.userProfile && this.props.userProfile.attributes) {
      let arrDate = this.props.userProfile.attributes.filter(item => item.name == type);
      if (arrDate.length > 0) {
        let date = moment(arrDate[0].value, 'DD/MM/YYYY');
        this.setState({
          birthday: date.toDate()
        });
      }
      return null;
    }
    return null;
  };

  handleChange = event => {
    this.setState({
      resourceVerify: event.target.value
    });
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.showModal}
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '80%' }}
        >
          <ModalHeader toggle={this.closeModal} />
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit} onInvalidSubmit={this.handleInvalidSubmit}>
              {/* <div className="row" style={{ padding: '15px' }}> */}
              <div className="row">
                <div className="col-3">
                  <label style={{ width: '100%' }}>Nguồn xác minh</label>
                </div>
                <div className="col-9">
                  <AvField name="resources" label="" type="select" value="" onChange={this.handleChange}>
                    <option key={Resources[6].key} value={Resources[6].key}>
                      {Resources[6].value}
                    </option>
                    {/* <option key={Resources[2].key} value={Resources[2].key}>
                      {Resources[2].value}
                    </option> */}
                    {/* <option key={Resources[5].key} value={Resources[5].key}>
                      {Resources[5].value}
                    </option> */}
                  </AvField>
                </div>
              </div>

              {this.state.resourceVerify === Resources[6].key ? (
                <div>
                  <div className="row">
                    <div className="col-3">
                      <label style={{ width: '100%' }}>
                        Họ và tên <strong style={{ color: '#FF0000' }}>*</strong>
                      </label>
                    </div>
                    <div className="col-9">
                      <AvField
                        name="cn"
                        value={this.bindingData('cn').length > 0 ? this.bindingData('cn')[0].value : ''}
                        validate={{
                          required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
                          maxLength: { value: 250, errorMessage: 'Họ tên quá dài' }
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : this.state.resourceVerify === Resources[2].key ? (
                <div className="row">
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label className="requiredLabel" style={{ marginRight: '30px' }}>
                      Mã số thuế
                    </label>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    <AvField
                      value=""
                      name="tax"
                      placeholder="Nhập mã số thuế"
                      type="text"
                      validate={{
                        required: { value: true, errorMessage: 'Bạn phải nhập mã số thuế.' },
                        pattern: {
                          value: '^([0-9]{10})+$',
                          errorMessage: 'Mã số thuế phải có 10 ký tự số'
                        },
                        maxLength: { value: 10, errorMessage: 'Mã số thuế phải có 10 ký tự' }
                      }}
                    />
                  </div>
                </div>
              ) : null}

              <div>
                <div className="row">
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label style={{ width: '100%' }}>
                      Số CMT<strong style={{ color: '#FF0000' }}>*</strong>
                    </label>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    <AvField
                      name="identity"
                      type="text"
                      value={this.bindingData('identity').length > 0 ? this.bindingData('identity')[0].value : ''}
                      readOnly={this.props.isUpdateIdentity ? false : true}
                      validate={{
                        required: {
                          value: this.props.isUpdateIdentity,
                          errorMessage: translate('register.messages.validate.onlyCMT.required')
                        },
                        pattern: {
                          value: '^([0-9]{9})+$',
                          errorMessage: translate('register.messages.validate.onlyCMT.minlength')
                        },
                        maxLength: { value: 9, errorMessage: 'Số cmt không được vượt quá 9 kí tự' }
                      }}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                    <label style={{ width: '100%' }}>
                      Số CCCD <strong style={{ color: '#FF0000' }}>*</strong>
                    </label>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-9'}>
                    <AvField
                      name="citizenId"
                      type="text"
                      value={this.bindingData('citizenId').length > 0 ? this.bindingData('citizenId')[0].value : ''}
                      readOnly={!this.props.isUpdateIdentity ? false : true}
                      validate={{
                        required: { value: !this.props.isUpdateIdentity, errorMessage: 'Bạn phải nhập số cccd' },
                        pattern: {
                          value: '^([0-9]{12})+$',
                          errorMessage: 'Số cccd phải có 12 kí tự số.'
                        },
                        maxLength: { value: 12, errorMessage: 'Số cccd không được vượt quá 12 kí tự' }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-3" />
                <div className="col-9">
                  <div className="row">
                    <div className="col-sm-3">
                      <Button className="btn-register-white" style={{ marginRight: 'auto' }} onClick={this.closeModal} block>
                        <span>Bỏ qua</span>
                      </Button>
                    </div>
                    <div className="col-sm-3">
                      <Button
                        className="btn-register"
                        style={{ marginRight: 'auto' }}
                        type="submit"
                        // onClick={() => this.setState({ stringType: 'null' })}
                        block
                      >
                        <span>Cập nhật</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userProfile: storeState.userInfo.userProfile,
  resUpdateAttr: storeState.userInfo.resUpdateAttr
});

const mapDispatchToProps = { updateAttributeWithDataResidential };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalUpdateDataWithResidential);
